import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import CollapsibleSnackBar from 'client/pages/MapPage/components/SnackBars/CollapsibleSnackBar/CollapsibleSnackBar';
import { mdiDomain } from '@mdi/js';
import NavLink from 'client/components/aria/NavLink/NavLink';
import { HELP_PAGE } from 'client/utils/routes/routeConstants';
import { selectAOIMode } from 'client/store/mapSlice/mapSlice';

const SupplementaryDataErrorSnackBar = () => {
    const intl = useIntl();
    // Intentionally only the global bulk-load error — per-feature fetch failures (state.supplementaryData.assetErrors)
    // are surfaced inline by the panel that requested them (e.g. RedactedAssetPanel), not via this snackbar
    const supplementaryError = useSelector(state => state?.supplementaryData?.error);
    const isAoiMode = useSelector(selectAOIMode);
    const visible = supplementaryError && isAoiMode;

    return (
        <>
            { visible && <SnackBar variant="warning">
                <CollapsibleSnackBar
                    icon={mdiDomain}
                    label={ intl.formatMessage({ id: 'supplementary.error.notification.label' })}
                    data-testid="supplementalError.alert"
                >
                    <FormattedMessage
                        id='supplementalError.alert'
                        values={{
                            serviceDesk: chunks => <NavLink to={HELP_PAGE}>{chunks}</NavLink>
                        }}
                    />
                </CollapsibleSnackBar>
            </SnackBar>
            }
        </>
    );
};

export default SupplementaryDataErrorSnackBar;
